import AcceptWithReasonModel from "Component/Modals/AcceptWithReasonModel";
import RejectWithReasonModel from "Component/Modals/RejectWithReasonModel";
import React, { useState } from "react";
import { Form } from "react-bootstrap";

const TableStatusOptionsAction = ({
  value,
  onChange,
  statusOptionArr,
  showRejectModel = false,
  showAcceptModel = false,
}) => {
  const [rejectModelStatus, setRejectModelStatus] = useState(false);
  const [acceptModelStatus, setAcceptModelStatus] = useState(false);
  const [rejectStatus, setRejectStatus] = useState("");
  const [acceptStatus, setAcceptedStatus] = useState("");

  const rejectSubmitHandler = (reason) => {
    onChange(rejectStatus, reason);
  };
  const acceptSubmitHandler = (reason) => {
    onChange(acceptStatus, reason);
  };
  const hideHandle = () => {
    setRejectModelStatus(false);
  };
  const hideAcceptModel = () => {
    setAcceptModelStatus(false);
  };

  return (
    <>
      <RejectWithReasonModel
        hideHandle={hideHandle}
        setCommissionModel={setRejectModelStatus}
        submitHandler={rejectSubmitHandler}
        show={rejectModelStatus}
      />
      <AcceptWithReasonModel
        hideHandle={hideAcceptModel}
        setCommissionModel={setAcceptModelStatus}
        submitHandler={acceptSubmitHandler}
        show={acceptModelStatus}
      />
      <Form.Select
        className="form-control rounded-pill w-auto h-auto fw-sbold"
        aria-label="Default select example"
        value={value}
        onChange={(e) => {
          console.log(e.target.value);
          if (
            ["decline", "2", "Dismissed"]?.includes(e.target.value) &&
            showRejectModel
          ) {
            setRejectStatus(e.target.value);
            setRejectModelStatus(true);
          } else if (
            ["Resolved"]?.includes(e.target.value) &&
            showAcceptModel
          ) {
            setAcceptedStatus(e.target.value);
            setAcceptModelStatus(true);
          } else {
            onChange(e.target.value);
          }
        }}
      >
        {statusOptionArr.map((item) => {
          return <option value={item.value}>{item.label}</option>;
        })}
      </Form.Select>
    </>
  );
};

export default TableStatusOptionsAction;
